export default __webpack_public_path__ + "static/media/halftone_sara.b0e703d4.png";